import { Leaf, Recycle, Droplets, PackageOpen } from "lucide-react";

const CARDS = [
  {
    icon: Recycle,
    title: "Kierrätettävä polypropeeni",
    text: "Suodatinten rungot on valmistettu polypropeenista (PP) – muovista, jonka voi kierrättää muovinkeräyksessä. Kun suodattimen käyttöikä on lopussa, anna materiaalille uusi elämä.",
  },
  {
    icon: Droplets,
    title: "Pienempi ekologinen jalanjälki",
    text: "Suodattamalla jo hanasta tuleva vesi säästät luontoa: puhdasta vettä ilman muovipulloja ja tarpeettomia kemikaaleja.",
  },
  {
    icon: PackageOpen,
    title: "Vaihda vain suodatin",
    text: "Runko kestää vuosia – vaihdat vain sisällä olevan suodattimen. Vähemmän jätettä, vähemmän turhaa kulutusta.",
  },
];

export default function SustainabilitySection() {
  return (
    <section data-testid="sustainability-section" className="bg-muted/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow justify-center" data-testid="sustainability-eyebrow">
            <Leaf size={14} /> Ajattelemme luontoa
          </p>
          <h2 className="h-section mt-4 font-heading font-semibold" lang="fi">
            Puhtaampaa vettä – kestävällä otteella
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            Haluamme, että JINSU on hyvä valinta sekä ihollesi että ympäristölle. Siksi tuotteidemme
            materiaalit ja elinkaari on suunniteltu vastuullisesti alusta asti.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {CARDS.map(({ icon: Icon, title, text }) => (
            <div
              key={title}
              data-testid={`sustainability-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl border border-border/60 bg-background p-8 shadow-sm transition-shadow duration-300 hover:shadow-lg"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <Icon size={24} strokeWidth={1.8} />
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
